// extracted by mini-css-extract-plugin
module.exports = {"tiny":"Stack_tiny__28hwF","small":"Stack_small__1kJLX","medium":"Stack_medium__7HR3V","large":"Stack_large__3vqeR"};